export default "__VITE_ASSET__$cm_Oz3v__"